'use client';

import { FC } from 'react';

import type { UnmappedField } from 'src/pdp/validation/validateVehicleGlassAttributes';

interface Props {
  invalidFields: UnmappedField[];
}

/**
 * Notification banner shown at the top of the PDP when the vehicle has unmapped
 * Glass attributes (e.g. Body Type, Fuel Type, Drive Type). Prevents broken filter
 * options on the live site and guides Content Publishers to fix metadata before publishing.
 */
export const UnmappedAttributesNotification: FC<Props> = ({ invalidFields }) => {
  if (invalidFields.length === 0) return null;

  return (
    <section
      className="c-se--default border-b border-bor-neu-mut bg-for-cau-lig py-3"
      role="alert"
      aria-live="polite"
      data-testid="unmapped-attributes-notification"
    >
      <div>
        <p className="c-fs-body1 font-extrabold text-tex-cau-tie1">
          Please review the following field values — they may be unmapped.
        </p>
        <ul className="c-fs-body2 list-none text-tex-cau-tie1">
          {invalidFields.map(({ field, label, value }) => (
            <li key={field}>
              <strong>{label}:</strong> {value}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
